import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import './MyAttendance.css';
import { selfAttendance } from '../../../services/monthlyAttendanceService';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import * as tf from "@tensorflow/tfjs";
import * as faceDetection from "@tensorflow-models/face-detection";
import "@mediapipe/face_detection";

const MyAttendance = () => {
    console.debug("🔄 Component Render");

    // Device detection function
    const getDeviceType = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        // Check for iOS
        const isIOS = /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        // Check for Android
        const isAndroid = /Android/.test(ua);

        // Check if it's a mobile device (any)
        const isMobile = /Mobile|Android|iPhone|iPad|iPod/i.test(ua);

        if (isIOS) return 'ios';
        if (isAndroid) return 'android';
        if (isMobile) return 'other-mobile';
        return 'desktop';
    };

    const deviceType = getDeviceType();
    const isIOS = deviceType === 'ios';
    const isAndroid = deviceType === 'android';
    const isMobile = isIOS || isAndroid || deviceType === 'other-mobile';

    // Show iOS warning if needed
    const [showIOSWarning, setShowIOSWarning] = useState(isIOS);

    // Rest of your existing code...
    const employeeName = localStorage.getItem("full_name") || "N/A";
    const employeeId = localStorage.getItem('employeeId') || "N/A";
    const employeeMn = localStorage.getItem('mobile') || "N/A";
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [selectedGodownId, setSelectedGodownId] = useState(null);
    const [successPopup, setSuccessPopup] = useState(false);

    const [location, setLocation] = useState({ latitude: null, longitude: null });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const [cameraActive, setCameraActive] = useState(false);
    const [capturedPhoto, setCapturedPhoto] = useState(null);
    const [stream, setStream] = useState(null);

    // Employee Info
    const [faceErrorPopup, setFaceErrorPopup] = useState(false);
    const [locationPopup, setLocationPopup] = useState(false);
    const [distanceFromGodown, setDistanceFromGodown] = useState(0);
    const [address, setAddress] = useState('');

    const [isCapturing, setIsCapturing] = useState(false);
    const fetchAddress = async (lat, lon) => {
        try {
            console.log("📍 Reverse geocoding started:", lat, lon);

            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`,
                {
                    headers: {
                        "User-Agent": "MyAttendanceApp/1.0 (support@yourdomain.com)",
                        "Accept": "application/json"
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }

            const data = await response.json();

            console.log("🧾 Full Nominatim response:", data);

            const addr = data.address || {};

            const fullAddress = [
               // addr.house_number,
               // addr.road,
                //addr.suburb,
                //addr.city || addr.town || addr.village,
                //addr.state,
               // addr.postcode
            ].filter(Boolean).join(', ');

            console.log(" Parsed Address:", fullAddress);
            console.log(" PIN Code:", addr.postcode || "NOT FOUND");

           // setAddress(fullAddress || "Address not found");

        } catch (error) {
            console.error("❌ Reverse geocode failed:", error);
           // setAddress("Address not available");
        }
    };


    console.debug(" Device Info:", { deviceType, isIOS, isAndroid, isMobile });
    console.debug(" Loaded Employee:", { employeeName, employeeId, employeeMn });

    const gd = localStorage.getItem('gd');
    const godowns = gd ? JSON.parse(gd) : [];

    useEffect(() => {
        if (godowns.length === 1) {
            setSelectedGodownId(godowns[0].godownId);
        }
    }, [godowns]);

    let selectedGodownData = godowns.find(g => g.godownId === selectedGodownId);

    // Restrict Access
    // useEffect(() => {
    //     console.debug(" Checking User Access...");

    //     const allowedIds = ["4G-20251016935475", "4G-20251016894060", "4G-20251016455281"];

    //     if (!allowedIds.includes(employeeId)) {
    //         console.warn("❌ Unauthorized User:", employeeId);
    //         alert("Access restricted to authorized personnel only.");
    //         navigate('/');
    //     } else {
    //         console.debug("✅ Authorized User");
    //     }
    // }, [employeeId, navigate]);

    const godownId = godowns.length > 0 ? godowns[0].godownId : null;

    useEffect(() => {
        if (godowns.length === 1) {
            setSelectedGodownId(godowns[0].godownId);
        }
    }, [godowns]);

    let model = null;

    const loadFaceModel = async () => {
        if (!model) {
            model = await faceDetection.createDetector(
                faceDetection.SupportedModels.MediaPipeFaceDetector,
                {
                    runtime: "tfjs",
                    maxFaces: 1,
                }
            );
            console.log(" Face Detection Model Loaded");
        }
    };

    const detectFace = async (imageDataUrl) => {
        await loadFaceModel();

        return new Promise((resolve) => {
            const img = new Image();
            img.src = imageDataUrl;
            img.onload = async () => {
                const faces = await model.estimateFaces(img);
                console.log("Faces Detected:", faces.length);
                resolve(faces.length > 0);
            };
        });
    };

    console.debug("🏬 Loaded Godown:", godownId);

    const today = new Date();
    const currentDate = format(today, 'dd-MM-yyyy HH:mm');

    // -------------------------
    // CAMERA HANDLING
    // -------------------------

    const cameraStarted = useRef(false);

    const startCamera = async () => {
        console.log("📸 startCamera() called");
        cameraStarted.current = true; // Use current ref flag

        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "user", width: { ideal: 720 }, height: { ideal: 720 } },
                audio: false
            });

            setStream(mediaStream);
            setCameraActive(true);

        } catch (err) {
            console.error("❌ Camera Error:", err);
            setSubmitMessage("Camera access blocked! Allow camera permission.");
            setMessageType("error");
            setCameraActive(false);
            cameraStarted.current = false;
        }
    };


    useEffect(() => {
        if (cameraActive && stream && videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.onloadedmetadata = () => {
                videoRef.current.play().catch(err => console.error("Play error:", err));
            };
        } else if (!cameraActive && videoRef.current) {
            videoRef.current.srcObject = null;
        }
    }, [stream, cameraActive]);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const lat = parseFloat(pos.coords.latitude.toFixed(6));
                    const lon = parseFloat(pos.coords.longitude.toFixed(6));
                    setLocation({ latitude: lat, longitude: lon });

                    // Fetch the full address immediately
                    fetchAddress(lat, lon);
                },
                (err) => { /* error handling */ }
            );
        }
    }, []);
    const capturePhoto = async () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!video || !canvas) return;

        setIsCapturing(true); // Start loading state

        try {
            if (video.readyState < 2) {
                await new Promise(resolve => video.onloadeddata = resolve);
            }

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Watermarking Logic
            if (location.latitude && location.longitude) {
                const fontSize = Math.floor(canvas.width * 0.025);
                const padding = 15;
                const lineHeight = fontSize + 5;
                const barHeight = lineHeight * 4;

                ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
                ctx.fillRect(0, canvas.height - barHeight, canvas.width, barHeight);
                ctx.fillStyle = "white";
                ctx.font = `bold ${fontSize}px Arial`;
                const timeText = format(new Date(), 'dd-MM-yyyy HH:mm:ss');
                ctx.fillText(`GPS: ${location.latitude}, ${location.longitude} | ${timeText}`, padding, canvas.height - barHeight + lineHeight + 5);

                // (Address wrapping logic remains the same as your original code)
                const words = address.split(' ');
                let line = '';
                let yPos = canvas.height - barHeight + (lineHeight * 2) + 5;
                for (let n = 0; n < words.length; n++) {
                    let testLine = line + words[n] + ' ';
                    if (ctx.measureText(testLine).width > (canvas.width - padding * 2) && n > 0) {
                        ctx.fillText(line, padding, yPos);
                        line = words[n] + ' ';
                        yPos += lineHeight;
                    } else { line = testLine; }
                }
                ctx.fillText(line, padding, yPos);
            }

            const photoDataUrl = canvas.toDataURL("image/jpeg", 0.9);
            const hasFace = await detectFace(photoDataUrl);

            if (!hasFace) {
                setFaceErrorPopup(true);
                setCapturedPhoto(null);
                if (stream) stream.getTracks().forEach(track => track.stop());
                setCameraActive(false);
                return;
            }

            // --- NEW LOGIC: Check Distance Immediately After Photo Capture ---
            if (selectedGodownId) {
                const selectedGodown = godowns.find(g => g.godownId === selectedGodownId);
                const dist = calculateDistance(
                    location.latitude,
                    location.longitude,
                    selectedGodown.latitude,
                    selectedGodown.longitude
                );
                setDistanceFromGodown(dist);

                if (dist > 0.15) { // 150 meters
                    setLocationPopup(true); // Show mismatch alert immediately
                }
            }

            setCapturedPhoto(photoDataUrl);
            if (stream) stream.getTracks().forEach(track => track.stop());
            setCameraActive(false);

        } catch (error) {
            console.error("Capture error:", error);
        } finally {
            setIsCapturing(false); // Stop loading state
        }
    };

    // Cleanup Camera on unmount
    useEffect(() => {
        return () => {
            console.debug("♻ Cleaning Up Camera On Unmount");
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [stream]);

    // Retake
    const retakePhoto = () => {
        console.debug("🔄 Retake Photo Clicked");
        setCapturedPhoto(null);
        startCamera();
    };

    // -------------------------
    // LOCATION
    // -------------------------
    useEffect(() => {
        console.debug("📍 Getting Location...");

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    console.debug("✅ Location Obtained:", pos.coords);

                    setLocation({
                        latitude: parseFloat(pos.coords.latitude.toFixed(6)),
                        longitude: parseFloat(pos.coords.longitude.toFixed(6)),
                    });
                },
                (err) => {
                    console.error("❌ Location Error:", err);
                    setSubmitMessage("Location access required");
                    setMessageType('error');
                }
            );
        } else {
            console.error("❌ Geolocation Not Supported");
        }
    }, []);

    // -------------------------
    // SUBMIT ATTENDANCE
    // -------------------------
    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371e3; // meters
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(Δφ / 2) ** 2 +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const meters = R * c;
        return meters / 1000;   // returns KM with decimal
    }

    function base64ToFile(base64, filename) {
        const arr = base64.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    const handleSubmit = async () => {
        console.debug("📤 handleSubmit() called");

        if (!selectedGodownId) {
            setSubmitMessage('Please select your working location!');
            setMessageType('error');
            return;
        }

        if (!location.latitude) {
            setSubmitMessage('Waiting for location...');
            setMessageType('error');
            return;
        }

        if (!capturedPhoto) {
            setSubmitMessage('Please take your selfie');
            setMessageType('error');
            return;
        }

        // FACE CHECK AGAIN
        const hasFace = await detectFace(capturedPhoto);
        if (!hasFace) {
            setSubmitMessage("Face not detected — please retake your photo.");
            setMessageType("error");
            setCapturedPhoto(null);
            startCamera();
            return;
        }

        // ----------------------------
        // LOCATION CHECK STARTS HERE
        // ----------------------------

        selectedGodownData = godowns.find(g => g.godownId === selectedGodownId);

        const dist = calculateDistance(
            location.latitude,
            location.longitude,
            selectedGodownData.latitude,
            selectedGodownData.longitude
        );

        setDistanceFromGodown(dist);

        console.log("📏 Distance from Godown:", dist, "meters");

        // If far away (>150m), show popup
        // if (dist > 150) {
        //     setLocationPopup(true);
        //     return;   // stop here until user clicks proceed
        // }

        // If within acceptable range — continue submit
        submitAttendance();
    };

    const submitAttendance = async () => {
        setIsSubmitting(true);
        setSubmitMessage('');
        setMessageType('');

        const file = base64ToFile(capturedPhoto, "selfie.jpg");

        let messageValue = null;
        if (distanceFromGodown > 0.2) {
            messageValue = `You are ${distanceFromGodown.toFixed(3)} km away from the location`;
        }

        const formData = new FormData();
        formData.append("employeeId", employeeId);
        formData.append("godownId", selectedGodownId);
        formData.append("latitude", location.latitude);
        formData.append("longitude", location.longitude);
        formData.append("message", messageValue);
        formData.append("selfieFile", file);

        try {
            const response = await selfAttendance(formData);
            const result = response.data;

            let messageText = "";

            if (typeof result === "object" && result.message) {
                messageText = result.message;
            } else if (typeof result === "string") {
                messageText = result;
            }

            // Success
            if (messageText.toLowerCase().includes("attendance captured")) {
                setSubmitMessage(messageText);
                setMessageType("success");
                setSuccessPopup(true);
            }
            // Duplicate / Already captured
            else if (messageText === "Attendance already captured for today!") {
                setSubmitMessage(messageText);
                setMessageType("duplicate");
            }
            // Any other error
            else {
                setSubmitMessage(messageText || "Failed to mark attendance");
                setMessageType("error");
            }
        } catch (err) {
            console.error(err);
            let errorMessage = "";

            if (err.response?.data) {
                if (typeof err.response.data === "string") errorMessage = err.response.data;
                else if (err.response.data.message) errorMessage = err.response.data.message;
            }

            if (errorMessage.toLowerCase().includes("already") || errorMessage.toLowerCase().includes("captured")) {
                setSubmitMessage(errorMessage);
                setMessageType("duplicate");
                setSuccessPopup(true); // Show popup for duplicate as well
            } else {
                setSubmitMessage(errorMessage || "Network error");
                setMessageType("error");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    // useEffect(() => {
    //     startCamera();
    // }, []);

    const godownOptions = godowns.map(g => ({
        value: g.godownId,
        label: `${g.godownName} (${g.district})`
    }));

    // 🚫 BLOCK ALL NON-iOS DEVICES
    if (!isIOS) {
        return (
            <div className="page-container">
                <div
                    className="attendance-card"
                    style={{
                        textAlign: 'center',
                        padding: '40px',
                        maxWidth: '400px',
                        margin: '40px auto'
                    }}
                >
                    <div style={{ fontSize: '60px', marginBottom: '20px' }}>🚫</div>

                    <h2 style={{ color: '#c0392b' }}>Access Restricted</h2>

                    <p style={{ color: '#555', marginTop: '15px', lineHeight: '1.6' }}>
                        This attendance feature is supported <b>only on iPhone (iOS) devices</b>.
                        <br />
                        Android and other devices are not allowed.
                    </p>
                </div>
            </div>
        );
    }



    return (
        <div className="page-container">
            {/* Add device info banner for debugging */}
            {isMobile && (
                <div style={{
                    backgroundColor: isIOS ? '#fff3cd' : '#d4edda',
                    color: isIOS ? '#856404' : '#155724',
                    padding: '8px 15px',
                    borderRadius: '4px',
                    marginBottom: '15px',
                    fontSize: '14px',
                    textAlign: 'center'
                }}>
                    📱 {isIOS ? 'iOS Device' : 'Android Device'} • Using {deviceType} mode
                </div>
            )}

            <h3 className="page-title">Mark Attendance</h3>

            <div className="attendance-card">
                <div className="card-body">

                    {/* INFO BLOCK */}
                    <div className="info-grid">

                        <div className=" text-nowrap label">Date & Time :</div>
                        <div className=" text-end valuea"> {currentDate}</div>

                        <div className="label">Work Location :</div>
                        <div
                            className={`valuea ${godowns.length === 1 ? "single-godown" : "multi-godown"}`}
                        >
                            {/* Case 1: Only One Godown */}
                            {godowns.length === 1 && (
                                <span className="single-text">{godowns[0].godownName}</span>
                            )}

                            {/* Case 2: Multiple Godowns */}
                            {godowns.length > 1 && (
                                <div style={{ width: "220px" }}>
                                    <Select
                                        options={godownOptions}
                                        value={godownOptions.find((opt) => opt.value === selectedGodownId) || null}
                                        onChange={(selected) => setSelectedGodownId(selected.value)}
                                        placeholder="Select Location"
                                        isSearchable
                                    />
                                </div>
                            )}
                        </div>

                    </div>

                    {/* CAMERA UI */}
                    <div className="camera-section">
                        {!cameraActive && !capturedPhoto && (
                            <button onClick={startCamera} className="action-btn primary-btn">
                                Attendance
                            </button>
                        )}

                        {/* Camera Live Feed */}
                        {cameraActive && (
                            <div className='capture-container'>
                                <div className="camera-preview">
                                    <video ref={videoRef} autoPlay playsInline muted></video>
                                    {/* Optional: Add an overlay loader on the video feed */}
                                    {isCapturing && (
                                        <div className="capturing-overlay">
                                            <h4 className=''>Capturing & Validating Face... Please Wait</h4>
                                        </div>
                                    )}
                                </div>

                                <button
                                    onClick={capturePhoto}
                                    className="capture-btn"
                                    disabled={isCapturing} // Disable button while processing
                                    style={{ opacity: isCapturing ? 0.7 : 1 }}
                                >
                                    {isCapturing ? 'Processing...' : 'Capture Photo'}
                                </button>
                            </div>
                        )}
                        {/* Captured Photo Preview */}
                        {capturedPhoto && (
                            <div className="photo-preview">
                                <img src={capturedPhoto} alt="Your selfie" />
                                <button onClick={retakePhoto} className="action-btn retake-btn">🔄 Retake Photo</button>
                            </div>
                        )}
                        {/* Hidden canvas for capturing the photo */}
                        <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
                    </div>

                    {/* Fallback Submit Button for photo taken state */}
                    {capturedPhoto && !cameraActive && (
                        <button onClick={handleSubmit} disabled={isSubmitting} className="submit-btn full-width" style={{ marginTop: '20px' }}>
                            {isSubmitting ? 'Please wait...' : 'Submit Attendance'}
                        </button>
                    )}

                    {/* MESSAGE */}
                    {submitMessage && (
                        <div className={`message ${messageType}`}>
                            <strong>
                                {messageType === 'success' && 'Success'}
                                {messageType === 'duplicate' && 'Already Marked'}
                                {messageType === 'error' && 'Error'}
                            </strong>: {submitMessage}
                        </div>
                    )}

                </div>
            </div>

            {faceErrorPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3 className="popup-title">❌ Face Not Detected</h3>
                        <p>Please retake your photo with your full face visible.</p>

                        <button
                            className="popup-btn"
                            onClick={() => {
                                setFaceErrorPopup(false);
                                startCamera();
                            }}
                        >
                            Retake Photo
                        </button>
                    </div>
                </div>
            )}

            {locationPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3 className="popup-title">⚠ You Are Not at the Selected Location</h3>

                        <p>You are <b>{distanceFromGodown.toFixed(2)} km</b> away from:</p>

                        <p><b>{selectedGodownData?.godownName}</b></p>

                        <p>Do you want to proceed?</p>

                        <div className="popup-btn-row">
                            <button
                                className="popup-btn cancel"
                                onClick={() => {
                                    setLocationPopup(false);
                                    setCapturedPhoto(null);
                                    startCamera();
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className="popup-btn proceed"
                                onClick={() => {
                                    setLocationPopup(false);
                                   // submitAttendance();
                                }}
                            >
                                Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {successPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3 className="popup-title">✅ Attendance Captured Successfully!</h3>
                        <p>Click OK to go to your dashboard.</p>
                        <button
                            className="popup-btn proceed"
                            onClick={() => navigate('/dashboard')}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyAttendance;